import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import Api from '../../api/global.service';
import "bootstrap/dist/css/bootstrap.css"
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import FormInput from '../../nuup/componentes/Forms/FormInput.jsx';
import FormSelectApi from '../../nuup/componentes/Forms/FormSelectApi.jsx';
import { Link } from "react-router-dom";
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import FormInputTextArea from '../../nuup/componentes/Forms/FormInputTextArea.jsx';
import procesarCola from '../../nuup/helpers/procesarCola';
import NoticiasUsuariosTabla from './NoticiasUsuariosTabla';
import Swal from "sweetalert2";
import BlockUi from 'react-block-ui';

const NoticiasEnviarForm = () => {
	const [centro] = useState(0);
	const [ruta] = useState(0);
	const [blocking, setBlocking] = useState(false);
	const [filterRole, setFilterRole] = useState('Productor');

	const schema = yup.object().shape({
		id_avisos_tipos_categoria : yup.number('Seleccione una categoría').min(1,'Seleccione una categoría').required('Seleccione una categoría'),
		titulo : yup.string('Introduzca título').required('Introduzca título'),
		aviso : yup.string('Introduzca aviso').required('Introduzca aviso'),
		descripcion : yup.string('Introduzca descripción').required('Introduzca descripción')
	});
	const [seleccionados,setSeleccionados] = useState([]);

	const { register, handleSubmit, formState: { errors } } = useForm({
		resolver: yupResolver(schema),
		mode: 'onBlur',
		defaultValues: {
			id_avisos_tipos_categoria : 0,
			titulo : '',
			aviso : '',
			descripcion : '',
		}
	});



	const onSubmit = data => {
		enviarNotificaciones(data);
	}

	
	const enviarNotificaciones = (data) => {
		if(seleccionados.length > 0){
			setBlocking(true);
			Api.create('avisos/noticias',{
				id_avisos_tipos_categoria : data.id_avisos_tipos_categoria,
				ids : seleccionados,
				titulo : data.titulo,
				aviso : data.aviso,
				descripcion : data.descripcion
			}).then(response => {
				setBlocking(false);
				procesarCola();
				let _result = response.data;
				if(_result.success === 1){
					Swal.close();
					Swal.fire(
						'Enviado!',
						'Notificaciones enviadas.',
						'success'
					);
				}
			}).catch(e => {
				setBlocking(false);
				Swal.fire(
				'Error!',
				'Error al enviar notificaciones.',
				'error'
				);
			});
			
		}else{
			setBlocking(false);
			Swal.fire(
				'Error',
				'Seleccione al menos un registro para enviar',
				'question'
			  )
			
		}


	};



	const handleSeleccionados = (_arr) => {
		console.log('handleSeleccionados');
		console.log(_arr);
		let _ids = [];
		for (let a = 0; a < _arr.length; a++) {
			_ids.push(_arr[a].id);			
		}
        setSeleccionados(_ids);
    }


	return (
		<>
		<div>
			<ol className="breadcrumb float-xl-right">
				<li className="breadcrumb-item"><Link to="/administracion/noticias">Registrar noticias</Link></li>
				<li className="breadcrumb-item active"></li>
			</ol>
			<h1 className="page-header">Administración de noticias <small></small></h1>

			<div className="row">
			<div className="col-md-12">

				<Panel>
					<PanelHeader>Datos de la noticia</PanelHeader>
					<PanelBody>
					<BlockUi tag="div" message="" blocking={blocking} renderChildren={true}>

 
						<form onSubmit={handleSubmit(onSubmit)}>
							<div className="row">
								<div className="col-md-12">
								<FormSelectApi 
									id="id_avisos_tipos_categoria"
									name="id_avisos_tipos_categoria"
									label="Categoría"
									url="notificaciones/categorias"
									keyArray="id_avisos_tipos_categoria"
									labelArray="aviso_categoria"
									showLoading={true}
									error={errors.id_avisos_tipos_categoria}
									register={register}
								/>
								</div>
							</div>

							<div className="row">
								<div className="col-md-12">
								<FormInput 
									id="titulo"
									type="text"
									name="titulo"
									label="Título"
									error={errors.titulo}
									register={register}
									/>
								</div>
							</div>

							<div className="row">
								<div className="col-md-12">
								<FormInput 
									id="descripcion"
									name="descripcion"
									label="Descripción (Se mostrará en la notificación Push)"
									error={errors.descripcion}
									register={register}
									/>
								</div>
							</div>

							<div className="row">
								<div className="col-md-12">
								<FormInputTextArea 
									id="aviso"
									name="aviso"
									label="Noticia"
									rows={5}
									error={errors.aviso}
									register={register}
									/>

								</div>
							</div>

							{/* Filters for users list */}
							<hr />
							<h5>Filtrar por:</h5>
							<div className="row">
								<div className="col-md-2">
									<select
										className='form-control'
										value={filterRole}
										onChange={(e) => setFilterRole(e.target.value)}
									>
									<option value={'Productor'}>Productor</option>
									<option value={'Administrador'}>Administrador</option>
									<option value={'Equipo'}>Equipo</option>
									</select>
								</div>
							</div>							
							
							{/* Users list */}
							<NoticiasUsuariosTabla 
								id_centro_colecta={centro} 
								id_ruta={ruta} 
								role={filterRole}
								onChangeSeleccionados={handleSeleccionados}
							/>

							<button className="btn btn-primary btn-block" type="submit">Enviar notificación</button>
						</form>			

						</BlockUi>
					</PanelBody>
				</Panel>
			</div>
			</div>
	

			</div>
		</>
	);
};
export default NoticiasEnviarForm;
